'use client'

import { Slider } from '@/core/ui/atoms/slider'
import { PostModel } from '@/features/blog/types/models/post.model'
import { Divider } from '@/features/content/ui/components'
import { useTranslations } from 'next-intl'
import { use } from 'react'
import { Post } from '../post'

type Props = {
  className?: string
  postsPromise: Promise<{ posts: PostModel[] }>
}

export const LatestUpdates: React.FC<Props> = ({
  className = '',
  postsPromise,
}) => {
  const t = useTranslations()
  const { posts } = use(postsPromise)

  return (
    <section className={`relative z-10 ${className}`}>
      <h2 className='text-4xl font-semibold'>{t('landing.latestUpdates')}</h2>
      <Divider className='mt-3' />

      <Slider
        slides={posts.map(post => (
          <Post key={post.id} {...post} />
        ))}
        showDots
        autoPlay
        delay={3000}
        slidesPerView={1}
        breakpoints={{
          768: 2,
          480: 1,
        }}
        className='child:child:mx-0 rtl:child:child:float-end my-8'
      />
    </section>
  )
}

export default LatestUpdates
